<template>
    <div class="app-container">
        <BjPage
          ref="BjPage"
          :query-params="queryParams"
          :col-span="colSpan"
          :get-action="queryApi"
          :serial="serial"
          :selection="selection"
          :before-reset-search="beforeResetSearch"
          @handleSelectionChange="handleSelectionChange"
          @showSetting="SortableTable.show"
          @header-dragend="SortableTable.handleHeaderDragend"
          @header-contextmenu="SortableTable.handleHeaderContextmenu"
        >
        <template v-slot:baseForm>
          <!-- 禁用日期 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.DisableDate')">
              <BjDateRangePicker v-model="queryParams_disableDate" :placeholder="$t('billingPage.DisableDate')" />
            </el-form-item>
          </el-col>
          <!-- 备注 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.remarkText')">
              <BjInput v-model="queryParams.remarks" :placeholder="$t('table.remarkText')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template>

        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
          </el-col>
        </template>

        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <!-- <template v-else-if="col.prop === 'date'">
                  <span>{{ scope.row[col.prop] }}</span>
                </template> -->
                <span v-else>{{ scope.row[col.prop] | timeFilters({isSession:true, dateFormat:'DD/MM/YYYY'}) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                <template slot-scope="props">
                    <el-button type="text" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                    <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
                </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import DataForm from './DataForm.vue';
  import { purchaseApi } from '@/api';
  import { STATUS_YES_TRUE, PURCHASE_TYPE_NUMBER} from '@/utils/constants';

  export default {
    name: 'BusinessPurchaseOrderTimeConfigure',
    components: {DataForm },
    mixins: [pageMiXin],
    props: {
      businessType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        PURCHASE_TYPE_NUMBER,
        STATUS_YES_TRUE,
        selection: false,
        colSpan: 4,
        // 查询参数
        queryApi: purchaseApi.getCsgPurchaseOrderTimeList,
        queryParams_disableDate: [],
        queryParams: {
          remarks: null,
          dateBegin: null,
          dateEnd: null,
        },
        labelList: [
          { label: this.$t('billingPage.DisableDate'), prop: 'date', isCheck: true, disabled: false },
          { label: this.$t('table.remarkText'), prop: 'remarks', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ]
      };
    },
    watch: {
        queryParams_disableDate(v) {
          this.queryParams.dateBegin = (v || [])[0];
          this.queryParams.dateEnd = (v || [])[1];
        },
    },
    methods: {
      /** 新增 */
      onAdd() {
        this.$refs.DataForm.show();
      },
      /** 编辑 */
      onEdit(v) {
        this.$refs.DataForm.show(v);
      },
      /** 删除 */
      onDelete(e) {
        purchaseApi.delCsgPurchaseOrderTimeList({ids: [e.id]}).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 1000);
          }
        });
      },
      beforeResetSearch() {
        this.queryParams_disableDate = null;
        this.queryParams.remarks = null;
        return new Promise(resolve => {
            resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
